import { useLiveQuery } from 'dexie-react-hooks';
import { Link } from 'react-router-dom';

import { TelegramLink } from '../components/TelegramLink.js';
import { db } from '../sync/db.js';
import { request } from '../sync/api.js';

/**
 * Колокольчик. Дублирует Telegram и работает офлайн: уведомления лежат
 * на устройстве, поэтому их видно даже когда связи нет неделю.
 */
export function NotificationsScreen(): JSX.Element {
  const notifications = useLiveQuery(
    () => db.notifications.orderBy('createdAt').reverse().limit(100).toArray(),
    [],
    [],
  );

  const markRead = async (): Promise<void> => {
    const now = new Date().toISOString();
    await db.notifications.toCollection().modify((notification) => {
      if (!notification.readAt) notification.readAt = now;
    });
    try {
      await request<{ ok: boolean }>(
        '/api/notifications/read',
        { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' },
        15_000,
      );
    } catch {
      // Без сети отметка останется локальной — при обмене сервер её догонит
    }
  };

  const unread = notifications.filter((notification) => !notification.readAt).length;

  return (
    <div className="min-h-screen px-4 py-6">
      <header className="mb-6 flex items-center justify-between gap-3">
        <h1 className="text-xl font-semibold">Уведомления</h1>
        <Link to="/" className="rounded-xl bg-muted px-4 py-3 text-base font-semibold">
          Назад
        </Link>
      </header>

      <section className="mb-6 rounded-xl bg-card shadow-card p-4">
        <TelegramLink />
      </section>

      {unread > 0 && (
        <button
          type="button"
          onClick={() => void markRead()}
          className="mb-4 w-full rounded-xl bg-muted px-5 py-4 text-lg font-semibold active:bg-line"
        >
          Отметить всё прочитанным ({unread})
        </button>
      )}

      {notifications.length === 0 ? (
        <p className="rounded-xl bg-card shadow-card p-4 text-base text-dim">Уведомлений нет</p>
      ) : (
        <ul className="flex flex-col gap-touch">
          {notifications.map((notification) => (
            <li
              key={notification.id}
              className={`rounded-xl p-4 ${notification.readAt ? 'bg-card shadow-card' : 'bg-muted'}`}
            >
              <p className="text-lg font-semibold">{notification.title}</p>
              <p className="mt-1 text-base text-body">{notification.body}</p>
              <p className="mt-2 text-base text-faint">
                {new Date(notification.createdAt).toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
